import List from 'src/storage/list';

class PatientsModel extends List {
  id = 'PatientsModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    tab: 'patients',
    pageIndex: 0,
    sortBy: {
      sortKey: 'addDate',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'patient/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'patient_list'
    },
    list: {
      url: 'patient/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'patient_list'
    },
    search: {
      url: 'patient/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'patient_list'
    },
    removePatient: {
      url: 'patient/remove',
      validation: {},
      cancellable: true
    }
  };
  _events = {
    'ws:modify_patient': 'onInvitePatient',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onInvitePatient = (data) => {
    if (data.removedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);
      this.trigger();
    }
  };

  _matchMergeItem = (n, o) => ({ ...o, ...n });

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      status: this.state.status,
      sortBy: this.state.sortBy
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }
  remove = (item, cb) => {
    let req = {
      patientId: item.id
    };
    this.api('removePatient', req, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };
}

const model = new PatientsModel();
export default model;
